import { render, staticRenderFns } from "./HomeCompanyResults.vue?vue&type=template&id=0b7d4ca8&"
import script from "./HomeCompanyResults.vue?vue&type=script&lang=js&"
export * from "./HomeCompanyResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports